module.exports = __webpack_public_path__ + "img/cash-flow.bfd11784.svg";